import { useDispatch } from 'react-redux';
import { ProUpsellModalActions } from '../redux/pro_upsell_modal';

export const useProUpsellModal = () => {
  const dispatch = useDispatch();
  const openProUpsellModal = () => {
    dispatch(ProUpsellModalActions.PRO_UPSELL_MODAL_OPEN());
  };
  const closeProUpsellModal = () => {
    dispatch(ProUpsellModalActions.PRO_UPSELL_MODAL_CLOSE());
  };

  return {
    openProUpsellModal,
    closeProUpsellModal,
  };
};
